module.exports = __webpack_public_path__ + "static/media/free-sign-up__3.bb8ad8e2.svg";